var _style, _path, _path2, _path3, _path4, _rect, _polygon, _path5, _path6, _polyline, _path7, _path8, _polygon2, _rect2, _polygon3, _ellipse, _ellipse2, _ellipse3, _path9, _polyline2, _path10, _path11, _polygon4, _ellipse4, _ellipse5, _ellipse6, _path12, _path13, _rect3, _polyline3, _path14, _path15, _path16, _path17, _path18, _path19, _polygon5, _polygon6, _polyline4, _path20;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 809.2 657.3",
    style: {
      enableBackground: "new 0 0 809.2 657.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#99D022;}\n\t.st1{fill:#3F3D56;}\n\t.st2{fill:#E6E6E6;}\n\t.st3{fill:#CCCCCC;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M692.5,601.2v49c0,3.9-3.1,7-7,7h-556c-3.9,0-7-3.1-7-7v-62.1c0.7-0.7,1.3-1.4,2-2.1 c147.6-153,391.3-157.4,544.3-9.8c7.5,7.3,14.7,14.8,21.7,22.7C691.2,599.7,691.9,600.5,692.5,601.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M353,578.7l-19.8,0.5c-3,0.2-6-0.7-8.5-2.4c-2.2-1.6-3.1-3.8-2.7-5.9l3.9-19.6c0.7-3.7,5.3-6.5,10.8-6.6l11-0.3 c5.5-0.2,10.2,2.4,11.1,6l5,19.4c0.6,2.1-0.3,4.4-2.4,6.1C359,577.7,356.1,578.7,353,578.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M473.7,578.1l-19.8,0.5c-3,0.2-6-0.7-8.5-2.4c-2.2-1.6-3.1-3.8-2.7-5.9l3.9-19.6c0.7-3.7,5.3-6.5,10.8-6.6 l11-0.3c5.5-0.2,10.2,2.4,11.1,6l5,19.4c0.6,2.1-0.3,4.4-2.4,6.1C479.6,577.1,476.7,578.1,473.7,578.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M284.2,411.6c-2.2-0.9-3.2-3.5-2.3-5.7c0.7-1.5,2.2-2.6,3.9-2.6l225.5-6.2c2.4-0.1,4.4,1.8,4.4,4.2l0,0l0,0 c0.1,2.4-1.8,4.4-4.2,4.4l0,0L286,412C285.4,412,284.8,411.9,284.2,411.6z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 305.9,
    y: 337.8,
    transform: "matrix(0.9996 -2.760376e-02 2.760376e-02 0.9996 -12.2001 9.5042)",
    className: "st2",
    width: 64.5,
    height: 217.7
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "369,333.1 356.6,366.8 356.6,520.6 371.7,524.9 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.8,280.1c-12.1,0.3-21.3,21.2-21,29.4l0.4,14.7l43.7-1.2l-0.4-14.7C357.2,300.1,346.9,279.8,334.8,280.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.8,428.9c-4.7,0.1-8.6-3.6-8.7-8.3l-0.7-24c-0.1-4.7,3.6-8.6,8.3-8.7s8.6,3.6,8.7,8.3l0.7,24 C312.2,424.8,308.5,428.7,303.8,428.9z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "320.1,339.3 319.8,323.4 324,323.3 324.3,339.1 328.1,569.5 323.9,569.6 "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M374.8,376.4l-74.7,2.1c-7.1-8.7-7.8-45.8,7.1-52.9l5.8-9.9l45-2.2l5.3,10.4 C370.7,330.2,374.5,367.1,374.8,376.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M346.6,358.6l-18.9,0.5c-3.6,0.1-6.7-4.6-6.9-10.5s2.7-10.8,6.3-10.9l18.9-0.5c3.6-0.1,6.7,4.6,6.9,10.5 S350.3,358.5,346.6,358.6z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "310,465.6 271.1,493.1 264.3,555.1 309.7,540 "
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 430.3,
    y: 335.2,
    transform: "matrix(0.9996 -2.760376e-02 2.760376e-02 0.9996 -12.081 12.9371)",
    className: "st2",
    width: 64.5,
    height: 217.7
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "428.9,333.8 442.1,367.2 446.1,520.9 431.1,525.6 "
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 524,
    cy: 262.6,
    rx: 8.4,
    ry: 11.3
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 568.2,
    cy: 428.9,
    rx: 8.4,
    ry: 11.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 239.5,
    cy: 397.1,
    rx: 8.4,
    ry: 11.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M458,277.5c-12.1,0.3-21.3,21.2-21,29.4l0.4,14.7l43.7-1.2l-0.4-14.7C480.4,297.5,470,277.2,458,277.5z"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "470.5,344.2 470.2,328.4 474.3,328.3 474.6,344.1 478.4,574.4 474.2,574.6 "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M497.9,373.7l-74.7,2.1c-1.3-7.9,0.4-44.6,7.1-52.9l5.8-9.9l45-2.2l5.3,10.4 C499.7,322.4,504.4,358.5,497.9,373.7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M469.9,359.3l-18.9,0.5c-3.6,0.1-6.8-5.4-7-12.2s2.6-12.5,6.3-12.6l18.9-0.5c3.6-0.1,6.8,5.4,7,12.2 S473.5,359.2,469.9,359.3z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "495,449.7 532.6,478.9 536.6,541.2 491.9,524 "
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 302.9,
    cy: 136.3,
    rx: 8.4,
    ry: 11.3
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 493,
    cy: 58.6,
    rx: 8.4,
    ry: 11.3
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 222.6,
    cy: 296,
    rx: 8.4,
    ry: 11.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M388.7,19.2c-12.1,0.3-21.3,21.2-21,29.4l0.4,14.7l43.7-1.2l-0.4-14.7C411.1,39.2,400.8,18.9,388.7,19.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M414.7,577.4l-19.8,0.5c-3,0.2-6-0.7-8.5-2.4c-2.2-1.6-3.1-3.8-2.7-5.9l3.9-19.6c0.7-3.7,5.3-6.5,10.8-6.6 l11-0.3c5.5-0.2,10.2,2.4,11.1,6l5,19.4c0.6,2.1-0.3,4.4-2.4,6.1C420.7,576.4,417.7,577.4,414.7,577.4z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 365.2,
    y: 113.8,
    transform: "matrix(0.9996 -2.760376e-02 2.760376e-02 0.9996 -9.0625 11.0981)",
    className: "st2",
    width: 64.5,
    height: 440
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "397.8,325.9 397.5,310.1 401.6,310 401.9,325.8 405.7,556.1 401.5,556.3 "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M436.2,153.3l-87.3,2.4c-1.5-9.2,0.4-52.1,8.3-61.8l2.2-11.5l60.3-1.7l3.2,11.2 C431.5,99.4,435.9,142.4,436.2,153.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M421.6,82.2l-62.2,1.7c-2.3,0.1-4.2-1.1-4.2-2.7c0-0.2,0-0.4,0.1-0.7l9.7-29.8c0.4-1.3,2.1-2.2,4-2.3l41.3-1.1 c1.9-0.1,3.6,0.8,4.1,2l11.3,29.2c0.6,1.5-0.8,3-3,3.5C422.2,82.1,421.9,82.2,421.6,82.2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M365.5,323.9c-0.6-0.2-1.1-0.5-1.6-0.9c-1.4-1-2.3-2.6-2.4-4.3l-2.3-81.9c-0.1-3.4,3.2-6.2,7.4-6.4l55.7-1.5 c4.2-0.1,7.6,2.5,7.7,5.9l2.3,81.9c0,1.7-0.8,3.4-2.1,4.4c-1.5,1.2-3.3,1.9-5.3,1.9l-55.7,1.5C368,324.7,366.7,324.4,365.5,323.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M401.1,76.9l-18.9,0.5c-3.6,0.1-6.7-4-6.9-9.2s2.7-9.4,6.4-9.5l18.9-0.5c3.6-0.1,6.7,4,6.9,9.2 S404.8,76.8,401.1,76.9z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M493.4,423.6c-4.7,0.1-8.6-3.6-8.7-8.3l-0.7-24c-0.1-4.7,3.6-8.6,8.3-8.7c4.7-0.1,8.6,3.6,8.7,8.3l0.7,24 C501.8,419.5,498.1,423.4,493.4,423.6z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183,491.6c-10.2,0-16.9-2.5-19.9-7.6c-5.8-10,3.9-27.5,28.9-52.1l2.1,2.1c-23.2,22.8-33.3,40-28.5,48.4 c3.1,5.3,12.3,7.2,26.6,5.5c14.2-1.7,33.1-6.8,56.1-15.1c47.3-17.1,106.6-45.9,167.1-81.1c60.4-35.2,114.8-72.6,152.9-105.3 c7.3-6.3,14-12.3,19.8-18c7.6-7.2,14.6-15,21-23.4c8.6-11.6,11.5-20.6,8.4-25.9c-5.2-8.9-26.9-8-61.2,2.4l-0.9-2.9 c36.8-11.1,58.5-11.5,64.6-1c3.8,6.5,0.9,16.3-8.5,29.2c-6.5,8.5-13.6,16.4-21.3,23.7c-5.8,5.7-12.5,11.8-19.9,18.1 c-38.3,33-92.7,70.6-153.3,105.9s-120.1,64.2-167.6,81.3c-23.2,8.4-42.3,13.5-56.7,15.2C189.5,491.4,186.2,491.6,183,491.6z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "423.3,139.3 460.9,168.5 464.9,230.8 420.2,213.6 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "366.4,139.3 328.7,168.5 324.7,230.8 369.5,213.6 "
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "387.6,93.8 387.3,78 391.5,77.9 391.8,93.7 395.6,124 391.4,124.1 "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M628.8,523.2c-9.1,0-19.1-0.5-29.9-1.5c-56.1-5.1-128.7-22.6-204.6-49.5c-75.8-26.9-145.7-59.8-197-92.7 c-24.9-16-44.1-31.2-56.8-45.1c-13.5-14.7-19.5-27.6-17.6-38.2c3.6-20.6,35.7-25.1,62.1-25.3v3c-36.1,0.2-57.4,8.4-60,23 c-3.3,18.6,23.5,47.7,73.3,79.8c51.1,32.9,120.9,65.7,196.6,92.6c75.7,26.8,148.2,44.4,204.1,49.4c54.7,4.9,87.8-2.9,91.2-21.6 c2.7-15.5-15.2-38.3-50.5-64.2l1-2.7c25.6,18.8,55.4,45.9,51.6,67.6c-1.8,10.6-11.3,18-28.2,21.9 C654.3,522.1,642.6,523.2,628.8,523.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.57f85f3d7a013d527800842c26761673.svg";
export { ForwardRef as ReactComponent };